import React, { Component } from 'react';
import * as _ from 'lodash';

import './styles.scss';

interface Option {
  value: string;
  default?: boolean;
  label: string;
  disabled?: boolean;
}

interface Props {
  className?: string;
  name: string;
  options: ReadonlyArray<Option>;
  style?: any;
  setValue: (value: any) => void;
}

class SegmentedControl extends Component<Props> {
  public componentWillMount() {
    const defaultOption = _.find(this.props.options, { default: true });

    if (defaultOption) {
      this.setValue(defaultOption.value);
    }
  }

  public setValue(value: any) {
    if (this.props.setValue) {
      this.props.setValue(value);
    }
  }

  public render() {
    const getId = (option: Option) => this.props.name + option.value;

    const style = this.props.style;

    let containerClassName = 'segmented-control';

    if (typeof this.props.className !== 'undefined') {
      containerClassName = `${containerClassName} ${this.props.className}`;
    }

    return (
      <div className={containerClassName} style={style}>
        {this.props.options.map(option => (
          <input
            key={option.value}
            type="radio"
            name={this.props.name}
            id={getId(option)}
            defaultChecked={option.default}
            aria-checked={option.default}
            disabled={option.disabled}
          />
        ))}
        {this.props.options.map(option => {
          const onClick = () => this.setValue(option.value);
          return (
            <label
              role="listitem"
              key={option.value}
              onClick={onClick}
              htmlFor={getId(option)}
              data-value={option.label}
            >
              {option.label}
            </label>
          );
        })}
      </div>
    );
  }
}

export default SegmentedControl;



// WEBPACK FOOTER //
// ./src/components/SegmentedControl/index.tsx